import React, { useEffect, useMemo } from 'react'
import { uniqueId } from 'lodash'
import SelectComponent from '../../../components/default-select'
import { InlineAddButton } from '../../../../civic-champs-shared/core/InlineAddButton'
import { PALETTE_COLORS } from '../../../../constants/colors'
import { RoleType, Timeshift } from '../model'
import { OptionType } from './shift'
import './multi-registration-lines.scss'

interface Props {
  timeshifts: Timeshift[]
  data: { shifts: { id: number; roleId: number | null; error: string; lineKey?: string }[] }
  addRegistrationLine: (timeshiftId: number, lineKey: string) => void
  setRegistrationLineRole: (lineKey: string, roleId: number) => void
  removeRegistrationLine: (lineKey: string) => void
  volunteerName: string
}

export default function MultiRegistrationLines(props: Props) {
  const timeshift = props.timeshifts[0]

  const roleOptions = useMemo(() => {
    if (!timeshift) {
      return []
    }
    return timeshift.roles
      .filter((item: RoleType) => item.available > 0)
      .map((item: RoleType) => ({
        label: item.name,
        value: String(item.id),
      }))
  }, [timeshift])

  const lines = props.data.shifts.filter(shift => shift.id === timeshift?.id)

  useEffect(() => {
    if (!timeshift || lines.length) {
      return
    }
    props.addRegistrationLine(timeshift.id, uniqueId('registration_line_'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeshift?.id])

  if (!timeshift) {
    return null
  }

  const shiftTime = `${timeshift.time_start} - ${timeshift.time_end}`

  return (
    <div className="multi-registration-lines">
      <div className="multi-registration-lines__time">{shiftTime}</div>
      <div className="multi-registration-lines__rows">
        {lines.map(line => {
          const selectedRole = roleOptions.find(option => option.value === String(line.roleId))

          return (
            <div className="multi-registration-lines__row" key={line.lineKey || `${line.id}-${line.roleId}`}>
              <div className="multi-registration-lines__name">{props.volunteerName}</div>
              <div className="multi-registration-lines__select">
                <SelectComponent
                  // @ts-ignore
                  value={selectedRole}
                  onChange={(option: OptionType) => {
                    props.setRegistrationLineRole(line.lineKey!, Number(option.value))
                  }}
                  options={roleOptions}
                  placeholder={'Choose Role'}
                />
                {line.error && (
                  <div className="multi-registration-lines__error" style={{ color: PALETTE_COLORS.textColors.error }}>
                    {line.error}
                  </div>
                )}
              </div>
            </div>
          )
        })}
        <InlineAddButton
          text="Add Registration"
          onClick={() => props.addRegistrationLine(timeshift.id, uniqueId('registration_line_'))}
        />
      </div>
    </div>
  )
}
